﻿import { defineComponent } from 'vue';

import { Booking } from "../../../services/booking";
import { booking_search_group } from "../../../objects/v1_2/Booking_Details/booking_search_group";
import { document } from "../../../objects/v1_2/Booking_Details/document";

let Book: Booking = new Booking();

export default defineComponent({
    name: "documentation_item",
    props: {
        document: document,
        index: { type: Number, default: 0 }
    },
    data() {
        return {
            Send_Documents: false,
            Sent: false,
            Failed: false,
            email: ""
        }
    },
    methods: {
        // Unique per document (was "email2" for every document).
        Email_Id(): string {
            return "document_email_" + this.index;
        },
        Valid_Email(): boolean {
            return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(this.email.trim());
        },
        async Email_Document(message_type: string) {
            if (!this.Valid_Email()) {
                return;
            }
            this.Send_Documents = true;
            this.Sent = false;
            this.Failed = false;
            try {
                await Book.Booking_Message(this.$store, this.message(message_type), this.email.trim(), String(this.$store.getters.get_Booking?.group_booking_id));
                this.Sent = true;
            } catch (error) {
                console.error(error);
                this.Failed = true;
            } finally {
                this.Send_Documents = false;
            }
        },
        message(message_type: string): string {

            switch (message_type) {
                case "Booking Statement":
                    return "Consumer_Statement";

                case "Booking Itinerary":
                    return "Consumer_Itinerary";

                case "Agent Statement":
                    return "Agent_Statement";
            }

            return message_type;
        }
    },
    mounted() {
    }
})